import { queryKeyFn } from '../../generated/sitContext';
export const getNotificationQueryKey = queryKeyFn({
    path: '/notifications',
    operationId: 'getApiNotifications',
    variables: {},
});
//# sourceMappingURL=query-key.js.map